import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';

import rawGetFormattedPrice from '@shared/helpers/rawGetFormattedPrice';
import PriceDetailsSummary from '@shared/pages/Hotels/helpers/PriceDetailsSummary';
import CustomTooltip from '@shared/components/Tooltip';

const HotelPriceInfo = ({
  hotel,
  rate,
  provider,
  integration,
  business_types,
  compare,
  isFromMap,
}) => {
  const [usdUserTooltip, setUsdUserTooltip] = useState(null);

  const isB2B = +business_types?.id === 2;
  const amountText = isB2B ? 'Neto total' : 'Precio total';

  const ratePrice = rate?.price;

  const formatPrice = byNight =>
    rawGetFormattedPrice({
      price: ratePrice,
      business_types,
      showPriceByNight: byNight,
    });

  const tooltipId = `usdTooltip-${hotel?.id_hotel}-${hotel?.id_integration}-${hotel?.id_provider}`;

  const handleMouseEnter = () => setUsdUserTooltip(tooltipId);
  const handleMouseLeave = () => setUsdUserTooltip(null);

  // Creamos un ID único para este tooltip

  return (
    <Grid
      item
      container
      xs={12}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        width: '100%',
        paddingBottom: '10px',
        position: 'relative',
      }}
    >
      <Grid
        item
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: { xs: 'flex-start', sm: 'center' },
          paddingTop: { xs: '10px', sm: 0 },
        }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            verticalAlign: 'text-bottom',
            color: 'black',
            fontWeight: 700,
            lineHeight: isFromMap ? 1 : 'auto',
            fontSize: { xs: isFromMap ? 18 : 20, sm: isFromMap ? 15 : 16 },
          }}
        >
          Precio por noche
        </Typography>

        <Typography
          sx={{
            color: 'red',
            fontWeight: 700,
            lineHeight: isFromMap ? 1.2 : 'auto',
            fontSize: { xs: isFromMap ? 19 : 20, sm: 16 },
          }}
        >
          {formatPrice(true)}
        </Typography>
      </Grid>

      <Typography
        sx={{
          color: 'gray',
          fontWeight: 600,
          lineHeight: isFromMap ? 1.2 : 1,
          fontSize: { xs: 18, sm: isFromMap ? 14 : 15 },
        }}
      >
        {amountText} {formatPrice(false)}
      </Typography>

      {compare && usdUserTooltip && (
        <CustomTooltip
          anchor={usdUserTooltip}
          elementId={tooltipId}
          stylesProp={{ top: '30px', minWidth: '150px', maxWidth: '220px' }}
        >
          <PriceDetailsSummary
            ratePrice={ratePrice}
            provider={provider}
            integration={integration}
            business_types={business_types}
            supplier={hotel?.supplier}
          />
        </CustomTooltip>
      )}
    </Grid>
  );
};

export default HotelPriceInfo;
